type Params = {
	amount: number;
	max: number;
	height: number;
	minHeight: number;
};

export const getBalanceBarHeight = ({
	amount,
	max,
	height,
	minHeight,
}: Params) =>
	Math.max(minHeight, Math.round((amount / Math.max(max, 1)) * height));
